import { api } from "@/frontend/services/api";
import type {
  ApiResponse,
  CreatePoolPredictionRequestDTO,
  PoolPredictionResponseDTO,
  UpdatePoolPredictionRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/pool-predictions/private";

export const poolPredictionService = {
  getByPool: (poolId: string) =>
    api.get<ApiResponse<PoolPredictionResponseDTO[]>>(`${BASE_URL}/pool/${poolId}`),
  getByPoolAndFixture: (poolId: string, fixtureId: string) =>
    api.get<ApiResponse<PoolPredictionResponseDTO[]>>(
      `${BASE_URL}/pool/${poolId}/fixture/${fixtureId}`,
    ),
  getById: (id?: string) =>
    api.get<ApiResponse<PoolPredictionResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreatePoolPredictionRequestDTO) =>
    api.post<ApiResponse<PoolPredictionResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdatePoolPredictionRequestDTO) =>
    api.put<ApiResponse<PoolPredictionResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
